<template>
    <div class="container text-center mtb-7 err-page" data-view>
        <h2 class="title color-blue">The Tribinnov Africa Community isn't available at the moment.</h2>
        <img src="/assets/img/about/missing.svg" alt="" class="img-fluid">
        <router-link to="/" class="link mt-5">Go Back Home</router-link>
    </div>
</template>

<script>
    export default {
        name: 'Community',
        metaInfo: {
            title: "Tribinnov Africa - Our Community",
            meta: [
                {
                    name: "description", content: "The Tribinnov Africa community or tribe for members"
                },
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>